'use client';

import { useEffect } from 'react';
import { toast } from '@/components/ui/sonner';
import { RefreshCwIcon } from 'lucide-react';

const STALE_ERROR_PATTERNS = [/_next\/action/, /Server Action/, /Failed to fetch/, /NetworkError/, /ChunkLoadError/, /Loading chunk/, /Loading CSS chunk/];

function isStaleClientError(error: Error): boolean {
  const message = error.message || '';
  const stack = error.stack || '';
  return STALE_ERROR_PATTERNS.some((pattern) => pattern.test(message) || pattern.test(stack));
}

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    if (isStaleClientError(error)) {
      toast({
        title: 'Update Required',
        description: 'Your app version is outdated. Please refresh to continue.',
        variant: 'warning',
        icon: <RefreshCwIcon className="size-4" />,
        duration: Infinity,
        dismissible: false,
        button: {
          label: 'Refresh Now',
          onClick: () => window.location.reload(),
        },
      });
    }
  }, [error]);

  return null;
}
